<template>
  <div
    :style="{
      borderStyle: 'solid',
      backgroundColor: 'transparent',
      borderWidth: `0 ${borderWidth} ${borderWidth} 0`,
      padding: width,
      cursor: 'pointer',
      transition: 'transform 300ms ease-in-out'
    }"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  props: {
    direction: {
      type: String
    },
    borderWidth: {
      type: String,
      default: '3px'
    },
    width: {
      type: String,
      default: '3px'
    }
  }
}
</script>

<style scoped>
.right {
  transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
}
</style>
